import { render, staticRenderFns } from "./Siderbar.vue?vue&type=template&id=450c8794"
import script from "./Siderbar.vue?vue&type=script&lang=js"
export * from "./Siderbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports